<chapps-list>
  <figure class="empty-state">
    <svg class="sprite icon">
      <use xlink:href="#action-type-default-thick"></use>
    </svg>
    <figcaption>{{ Localization.EmptyProcessingScreenMessage | translate }}</figcaption>
  </figure>
</chapps-list>
<!--<app-assign-modal (success)="onActionsAssigned()"></app-assign-modal>-->
